<div class="terms-and-conditions-container">
  <div class="terms-header">
    <h3>Terms and Conditions</h3>
  </div>

  <div class="terms-content">
    <h4>Article - 1 General Terms</h4>
    <ol class="one">
      <li>
        <p>
          The client has absolute discretionary power to make investment decisions and may from time to time instruct the Authorised
          Representative (A/R) to make such investment(s) for and on behalf by the following means of communication:
        </p>
        <ul>
          <li>(a) Order Slip of CAL Securities Limited.</li>
          <li>(b) Written instruction signed by the client</li>
          <li>(c) Faxed instruction signed by the client</li>
          <li>(d) Other evidence of order recorded through any electronic devices accepted by the CAL Securities Limited.</li>
        </ul>
      </li>

      <li>
        The means of Communication shall constitute evidence of orders made by the client to the AR, which when executed shall be conclusive
        and binding on the client.
      </li>
      <li>
        <p>
          All instruction and orders made by the client over telephone or any other electronic and electrical devices shall be logged by the
          AR in its system and such records shall be conclusive that the instructions have given by the client and the transactions so
          ordered or instructed shall be binding on the client.
        </p>

        <ul>
          <li>(a) Order Slip of CAL Securities Limited.</li>
          <li>(b) Written instruction signed by the client</li>
          <li>(c) Faxed instruction signed by the client</li>
          <li>(d) Other evidence of order recorded through any electronic devices accepted by the CAL Securities Limited.</li>
        </ul>
      </li>
      <li>
        <p>
          Order by electronic transmission to the AR shall be made at the risk of the Client and the AR shall under no circumstance be held
          responsible for any loss due to non-transmission arising out of any electronic, electrical or mechanical fault.
        </p>
      </li>

      <li>
        <p>
          In case of telephonic and e-mail support, CAL Securities Limited will only correspond to those number(s) and address that have
          been provided in the account opening form.
        </p>
      </li>

      <li>
        <p>
          In case of telephonic order, Client/POA holder has to sign buy/sell order within 24 hours after the execution of his trade order.
        </p>
      </li>
      <li>
        <p>
          If this is a Joint Account, unless the account holders notify CAL Securities Limited otherwise and provide such documentation, as
          CAL Securities Limited. may require, the brokerage customer account(s) shall be held by the account holders jointly with rights of
          survivorship (payable to either or survivor). Under these terms and conditions each joint account holder irrevocably appoints the
          other as attorney in fact to take all action on his or her behalf and to represent him or her in all respects in connection to
          this agreement. CAL Securities Limited shall be fully protected in acting but shall not be required to act upon the instruction of
          either of the account holder, who shall be liable, jointly or severally, for any amounts due to CAL Securities Limited pursuant to
          this agreement, whether incurred by either or both of the account holders. Unless and otherwise it is mentioned in case of joint
          account. both the account holder will be treated as equal partner and in case of death and any other accident the account balance
          will be divided equally to the joint account holders or their respective nominees. if any.
        </p>
      </li>
      <li><p>Margin Agreement has to be signed properly before availing Loan.</p></li>
      <li><p>The Account Holder must show his/her latest portfolio to AR before placing an order.</p></li>
      <li><p>The client shall be eligible to purchase only securities approved by the Management in his/her Margin Account.</p></li>
      <li>
        <p>
          The Management may, as its discretion, from time to time add new securities to or remove existing securities from the list of
          approved securities.
        </p>
      </li>
      <li><p>The client cannot sell any instrument until the instrument is sellable/matured.</p></li>
      <li>
        <p>
          The client shall only be allowed to buy a particular instrument if he/she has purchase power to buy that instrument in his/her
          Margin Account.
        </p>
      </li>
      <li>
        <p>
          The client has to sign pay in slip and trade confirmation after execution of his/her given order. 1-16 If the value of an order of
          the client exceeds the purchasing power of the client, which will be determined by the available cash and Margin Loan in the
          account, the AR shall have the discretion either to reject the order or modify the order by reducing the order quantity and/or
          eliminating a specific order in his/her Margin Account.
        </p>
      </li>
      <li>
        <p>
          The AR upon acceptance of an order shall undertake necessary steps to execute such orders of the client. If the Means of
          Communication is not satisfactory, the AR shall not be obliged to comply with such order but revert back to client for
          clarification.
        </p>
      </li>
      <li>
        <p>
          If the value of an order of the client exceeds the purchasing power of the client, which will be determined by the available cash
          and Margin Loan in the account, the AR shall have the discretion either to reject the order or modify the order by reducing the
          order quantity and/or eliminating a specific order in his/her Margin Account
        </p>
      </li>
      <li>
        <p>
          The sole responsibility for making investment decision shall be on the client and the AR will not make any discretionary
          investment decision for or on behalf of the client.
        </p>
      </li>
      <li>
        <p>
          The AR shall under no circumstance be responsible or liable for any result whether adverse or otherwise of the investment
          decisions of the Client.
        </p>
      </li>
      <li>
        <p>
          The client acknowledges that the AR neither guarantees any rate of return nor profit from any investment to the client nor shall
          be responsible for any losses caused to the client due to fluctuations of the capital market.
        </p>
      </li>
      <li>
        <p>
          The client may from time to time appoint or remove any person as Authorized Person/Power of Attorney holder to act on behalf of
          the client.
        </p>
      </li>
      <li>
        <p>
          Such Authorized Person shall be able to do all acts and give instructions or orders for all transactions under this Agreement,
          including operating the account(s) of the client and shall be acting for and on behalf of the client or described in the power of
          attorney declaration by the client until he/she removed in the manner stipulated hereunder.
        </p>
      </li>
      <li>
        <p>
          The AR may act on the instructions of an Authorized Person until it actually receives written notice from the client of the
          removal of such Authorized Person and may El any event act on any instructions issued by the Authorized Person before the date of
          receipt of the written notice of such removal.
        </p>
      </li>
      <li>
        <p>
          The client shall bear the full responsibility of the acts or omission of its authorized person. The AR shall not be held liable
          for any irregularities or unauthorized acts committed by the Authorized Person including and not limited to, unauthorized placing
          of securities purchase/sale orders or withdrawal of fund/securities.
        </p>
      </li>
      <li>
        <p>
          In case of client is a limited company, institution, association, trust or a firm, the signatories to this Agreement shall provide
          full corporate documents including board approvals and shareholders' approval(if any) supporting the appointment of the Authorized
          Person prior to the agreement.
        </p>
      </li>
      <li>
        The client shall solely responsible for notifying the Bangladesh Securities and Exchange Commission and other concerned authorities
        in the case of acquiring substantial shares of a company and/or trading shares of companies in which the client holds Directorship
        or in other case where it is obligatory to notify the regulatory authorities. Article -
      </li>
    </ol>

    <h4>Article - 2 Fees Charges and Interest</h4>
    <ol class="two">
      <li>
        <p>
          The account holder will pay a brokerage commission of...................... (in
          words)............................................) and any other related expenses and charges that may from time to time be
          applicable. Every transaction concluded through and recognized by the DSE or the CSE is subject to transaction levies or other
          fees imposed by the DSE & CSE. The account holder understands that he rate of commission may be changed from time to time.
        </p>
      </li>
      <li>
        <p>
          The account holder will pay interest at the rate of.......................in his/her margin account.The account holder understands
          that the rate of commission may be changed from time to time.
        </p>
      </li>
    </ol>

    <h4>Article - 3 Nominee</h4>
    <ol class="three">
      <li>
        <p>
          In the event of death of the Client. the nominee(s) as prescribed by the Client in the application form shall be the only
          person(s) recognized by the Management as being entitled to the asset of the portfolio.
        </p>
      </li>
      <li>
        <p>
          In case nominee(s) are not mentioned, the Management shall not be obliged to deal with any person or persons accept any right,
          title or interest of any person unless such person in holding a valid succession certificate probate or letter of administration
          covering the investment from a court of competent jurisdiction and subject to such further documents or evidence that the
          Management may require.
        </p>
      </li>
    </ol>

    <h4>Article - 4 Notice</h4>
    <ol class="four">
      <li>
        <p>
          Any notice provided for in this Agreement shall be in writing and shall be first transmitted by facsimile transmission, and then
          confirmed by registered mail or courier service, in the manner as elected by the party giving such notice to the addresses
          provided in account opening form. Article -
        </p>
      </li>
      <li>
        <p>All notices shall be deemed to have been validity given on</p>

        <ul>
          <li>(i) the Business Day when the transmission was made, if transmitted by facsimile transmission, or</li>

          <li>(ii) the expiry of 3 (three) Business Day after posting if transmitted by registered mail or</li>

          <li>(iii) the Business day of receipt, if transmitted by courier.</li>
        </ul>
      </li>
      <li>
        <p>
          Any party may, from time to time, change its address or representative for receipt of notices provide for in this Agreement by
          giving to the other party. not less than 10 (ten) days prior written notice.
        </p>
      </li>
      <li>
        <p>
          Client has to strictly follow the laws. rules and regulation of all the regulatory bodies. 4-3 Any party may, from time to time,
          change its address or representative for receipt of notices provide for in this Agreement by giving to the other party. not less
          than 10 (ten) days prior written notice.
        </p>
      </li>
      <li>
        <p>In case of deposit through cheque, the client cannot trade until his/her deposited cheque is matured.</p>
      </li>
      <li>
        <p>
          In case of cash deposit, the client can deposit a maximum amount of Taka 8.75 (Eight Lac and Seventy Five Thousand) cash to the
          respective bank referred by the CAL Securities Limited in any given day.
        </p>
      </li>
      <li>
        <p>
          In case of money withdrawal, Client has to submit a fund withdrawal requisition either hard copy or email to “
          info&64;calbd.com.bd” with duly signed or from client’s registered email ID. CAL Securities Limited may issue cheque in the name
          of AP/POA subject to client has to submit a Registered POA Agreement from 1st Class Magistrate. In this case, CAL Securities
          Limited’s decision will be full and final.
        </p>
      </li>
      <li>
        <p>If any change(s) regarding account information, client must place a written request to the CEO of CAL Securities Limited.</p>
      </li>
      <li>
        <p>
          Client must check and verify all documents he/she receives from CAL Securities Limited and make sure that those documents are duly
          signed by Authorized Person of the company. Once satisfied he/she should sign in those documents. If any documents is not duly
          signed by the Authorized Signature of any employee then client cannot make any complain against that particular document
        </p>
      </li>
    </ol>

    <h4>Article - 5 Termination of Agreement</h4>
    <ol class="five">
      <li>
        <p>
          This agreement shall continue in force until terminated by either party giving to the other not less than 30 (Thirty) Business
          Days' notice in writing provided that either party may upon serving written notice to terminate this Agreement in occurrence of
          any once of the following events :
        </p>

        <ul>
          <li>
            (a) The other party is in breach of material terms of this Agreement, which shall not been remedied within 15 (Fifteen) days
            after serving of written notice requiring the breach to be remedied.
          </li>
          <li>
            (b) The other party shall go into bankruptcy or liquidation, a resolution is passed for its winding up or a receiver or similar
            officer is appointed over any assets of the party.
          </li>

          <li>
            (c) Occurrence of any other matter that causes permanent disability for the Manager to carry out portfolio management functions.
          </li>
        </ul>
      </li>
      <li>
        <p>
          The company reserves the right and sole discretion to liquidate the Portfolio of the Client in whole or in part without notice to
          the Client when total investment of the account holder falls below 125% of the debit balance in the margin account to bring the
          equality to not less than 150% of the debit balance.
        </p>
      </li>
    </ol>

    <h4>Article - 6 Governing law and jurisdiction</h4>
    <ol class="six">
      <li>
        <p>This agreement shall be governed by the law of Bangladesh. Article _ 6 Governing law and jurisdiction</p>
      </li>
    </ol>

    <h4>Article - 7 Miscellaneous</h4>

    <ol class="seven">
      <li>
        <p>
          CAL Securities Limited shall be fully authorised to modify or vary the terms and conditions contained herein for compliance with
          any prevailing or change of relevant laws relating to matters herein.
        </p>
      </li>
      <li>
        <p>
          The Schedule(s) and any rider(s) attached hereto including the Account Opening Form, together with this Agreement shall constitute
          the entire Agreement between the parties hereto and supplement this Agreement.
        </p>
      </li>
      <li>
        <p>
          This Agreement is or shall be in compliance with the Bangladesh Securities and Exchange Commission (BSEC) laws and such rules,
          regulations, notices or circular issued by the Bangladesh Securities and Exchange Commission from time to time. I/we have read the
          terms and conditions contained herein above. and having agreed with such terms and conditions. I/we put my/our/company seal and
          signature on this the day of , 20 First A
        </p>
      </li>
    </ol>
  </div>

  <div class="terms-footer">
    <p class="last-updated">
      I/we have read the terms and conditions contained herein above. and having agreed with such terms and conditions
    </p>
  </div>
</div>
